// @ts-check
import { addEvent, getAttr, hasClass, query, queryAll, removeEvent } from 'matt-utils';

/**
 * Shop Price Filter
 */
class CollPrice extends HTMLElement {

  /**
   * Shop Price Filter
   */
  constructor() {

    super();
    this._cambio = this._cambio.bind( this );
    this._cambioInpt = this._cambioInpt.bind( this );

  }

  /**
   * Mappa un range su un altro range
   *
   * @param {number} val - valore
   * @param {number} min - minimo
   * @param {number} max - massimo
   * @param {number} newMin - nuovo minimo
   * @param {number} newMax - nuovo massimo
   *
   * @returns {number} - numero nel nuovo range
   */
  _map( val, min, max, newMin = 0, newMax = 100 ) {
    return ( ( val - min ) * ( newMax - newMin ) / ( max - min ) ) + newMin;
  }

  /**
   * Aggiunta eventi
   */
  connectedCallback() {

    const _this = this;

    queryAll( '.sh__inp', this ).forEach( ( el ) => {
      addEvent( el, 'input', this._cambio );

      // Fix per firefox
      _this._cambio({ target: el });
    });

    queryAll( '.sh__prez-inpt', this ).forEach( ( el ) => {
      addEvent( el, 'input', this._cambioInpt );
    });

  }

  /**
   * Rimozione eventi
   */
  disconnectedCallback() {

    queryAll( '.sh__inp', this ).forEach( ( el ) => {
      removeEvent( el, 'input', this._cambio );
    });

    queryAll( '.sh__prez-inpt', this ).forEach( ( el ) => {
      removeEvent( el, 'input', this._cambioInpt );
    });

  }

  /**
   * Evento cambio range
   *
   * @param {Event} evt - evento
   */
  _cambio( evt ) {

    const minEl = query( '.sh__inp-min', this ),
      maxEl     = query( '.sh__inp-max', this );

    let minVal = parseInt( minEl.value ),
      maxVal   = parseInt( maxEl.value );

    const min = this._map(
        minVal,
        parseInt( getAttr( minEl, 'min' ) ),
        parseInt( getAttr( minEl, 'max' ) ) // eslint-disable-line comma-dangle
      ),
      max     = this._map(
        maxVal,
        parseInt( getAttr( maxEl, 'min' ) ),
        parseInt( getAttr( maxEl, 'max' ) ) // eslint-disable-line comma-dangle
      );

    if ( maxVal < minVal ) {

      if ( hasClass( evt.target, 'sh__inp-min' ) ) {
        minEl.value = maxVal;
        minVal = maxVal;
      }

      maxEl.value = minVal;
      maxVal = minVal;

    }

    query( '.sh__prez-min' ).value = minVal;
    query( '.sh__prez-max' ).value = maxVal;

    queryAll( '.sh__inp', this ).forEach( ( el ) => {

      el.style.setProperty( '--min', `${min}%` );
      el.style.setProperty( '--max', `${max}%` );

    });

  }


  /**
   * Evento cambio input
   */
  _cambioInpt() {

    query( '.sh__inp-min' ).value = query( '.sh__prez-min' ).value;
    query( '.sh__inp-max' ).value = query( '.sh__prez-max' ).value;

    this._cambio({ target: query( '.sh__prez-min' ) });

  }

}

customElements.define( 'coll-price', CollPrice );